import React from 'react'

export default function BoxIDs({ ident }) {
    return(
          <div >{ident[0]} ({ident[1]})</div>
    )
}
